module.exports = __webpack_public_path__ + "img/Middle-2-Bevel-Attachment-36.6e9b8531.png";